
  import {mapGetters} from "vuex";
  import HourOverviewClockingHistory from "./HourOverviewClockingHistory.vue";
  import {HeaderGetters} from "@/store/modules/header";
  import {AuthGetters, AuthModule} from "@/store/modules/auth";
  import EmployeeService, {EmployeeWorklogDayV3Dto} from "@/service/EmployeeService";
  import Vue from "vue";
  import {AxiosError} from "axios";
  import {isAuthorized} from "@/mixin/mixins";

  export default Vue.extend({
    name: "HourOverview",
    components: {
      HourOverviewClockingHistory
    },
    data: () => ({
      blur: false,
      itemsPerPage: -1,
      totalHours: "",
      days: new Array<EmployeeWorklogDayV3Dto>(),
      showPassengerColumn: false
    }),
    computed: {
      ...mapGetters({
        month: "header/" + HeaderGetters.GET_MONTH,
        employeeUuid: AuthModule + "/" + AuthGetters.GET_EMPLOYEE_UUID
      }),
      dateColumnFormat (): string {
        return this.$vuetify.breakpoint.xs ? "DD.MM (dd)" : "DD.MM (dddd)";
      },
      groupedItems (): Array<any> {
        return this.days.map(day => ({
          date: day.date,
          // The clocking history shows the worklogs in the field names of the v1/v2 worklog
          items: day.worklogs.map(worklog => ({
            id: worklog.id,
            start: worklog.start,
            end: worklog.end,
            worklogType: worklog.type,
            order: worklog.order,
            comment: worklog.comment
          })),
          start: day.worklogs[0].start,
          end: day.worklogs[day.worklogs.length - 1].end,
          timeSpent: day.totals
        }));
      }
    },
    watch: {
      month (newMonth) {
        this.loadMonth(newMonth);
      },
      $route () {
        this.loadMonth(this.month);
      }
    },
    mounted () {
      this.showPassengerColumn = isAuthorized("Accounting_Employee_ViewPassengerTimes");
      this.loadMonth(this.month);
    },
    created () {
      this.blur = false;
    },
    methods: {
      openDetails (item: any) {
        this.blur = true;
        // @ts-ignore
        this.$refs.hourOverviewClockingHistory.open(item);
      },
      detailsClosed: function () {
        this.blur = false;
      },
      loadMonth (date: string) {
        // The hour overview always shows the logged-in employee, whose uuid the authentication carries
        EmployeeService.getEmployeeWorklogsV3(this.employeeUuid as string, date)
          .then(worklogs => {
            this.days = worklogs.days;
          }).catch((error: AxiosError<any>) => {
            this.$eventBus.$emit("error", error);
          });
      },
      toStartEnd: function (item: any) {
        return item.start + " - " + item.end;
      }
    }
  });
